import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

@Component({
  selector: 'app-ip-title-mobile',
  templateUrl: './ip-title-mobile.component.html',
  styleUrls: ['./ip-title-mobile.component.scss']
})
export class IpTitleMobileComponent implements OnInit {
  @Input() title = '';
  @Input() btn: 'create' | 'filter' | 'settings' | 'none' = 'none';
  @Input() btnText?: string;
  @Input() back = false;
  @Input() noBackground = false;
  @Input() textEnd = false;
  @Output() clicked = new EventEmitter<any>();
  mobile!:boolean;
  @Input('remove-mg-bottom-mobile') removeMgBottomMobile: boolean = false;
  @Input('remove-mg-bottom-desktop') removeMgBottomDesktop: boolean = false;
  @Input() withAvatar: boolean = false;
  @Input() avatarUrl?: string;
  @Output() clickedAvatar = new EventEmitter<any>();

  constructor(private location: Location) {}

  ngOnInit(): void {
    this.checkIfMobile()
  }

  onClickButton(ev: MouseEvent) {
    this.clicked.emit(ev);
  }

  goBack() {
    this.location.back();
  }

  @HostListener('window:resize')
  checkIfMobile() {
    this.mobile = window.innerWidth <= 768;
  }

  onClickAvatar(ev: MouseEvent) {
    this.clickedAvatar.emit(ev);
  }

}
